<script lang="ts">
  import type { Snippet } from "svelte";
  import type { HTMLButtonAttributes } from "svelte/elements";

  interface Props extends HTMLButtonAttributes {
    variant?: "primary" | "ghost" | "danger" | "secondary";
    size?: "normal" | "compact";
    children?: Snippet;
  }

  const {
    variant = "primary",
    size = "normal",
    type = "button",
    class: extraClass = "",
    disabled = false,
    children,
    ...rest
  }: Props = $props();

  const variantClass = $derived(
    variant === "ghost"
      ? "ghost-button"
      : variant === "danger"
        ? "ghost-button danger"
        : variant === "secondary"
          ? "button secondary"
          : "button",
  );

  const sizeClass = $derived(size === "compact" ? "compact" : "");
  const computedClass = $derived([variantClass, sizeClass, extraClass]);
</script>

<button {type} class={computedClass} {disabled} {...rest}>
  {@render children?.()}
</button>
